import { setLocale } from 'yup'

export function setYupLocales(t: (v: string, args?: any) => string) {
  setLocale({
    mixed: {
      default: t('forms.invalid'),
      required: t('forms.required'),
      notNull: t('forms.required'),
      oneOf: t('forms.required'),
      notOneOf: t('forms.required'),
      notType: t('forms.required'),
      // Add more default error messages for mixed type validations
    },
    string: {
      email: t('forms.email'),

      // Add more default error messages for string type validations
    },
    array: {
      min: min => t('forms.required', { min }),
      max: max => t('forms.required', { max }),
    },
    number: {
      min: min => t('forms.min', { min }),
      max: max => t('forms.max', { max }),
      positive: t('forms.positive'),
      // Add more default error messages for number type validations
    },
  })
}
